/* src/app/components/billing/reports/summary-report/summary-report.component.css */
.summary-heading {
  background-color: #bebdf575;
  padding: 4px;
  border-radius: 4px;
  font-size: 1.286rem;
  margin-bottom: 10px;
  margin-top: 0;
  font-weight: 500;
}
.summary-container {
  display: block !important;
  padding: 16px 36px !important;
}
.report-label {
  margin-bottom: 4px;
  font-weight: 600;
}
/*# sourceMappingURL=summary-report.component-ZH6J3ZD5.css.map */
